<template>
  <form action="javascript:void(0)">
              <div class="checkbox-form">
                <h3>Billing Details</h3>
                <!-- BILLING FORM HERE  -->
                <billing-form :countries="countries" />

                <div class="row">
                  <div class="col-md-12">
                    <div class="checkout-form-list create-acc">
                      <input id="cbox" type="checkbox">
                      <label>Create an account?</label>
                    </div>
                    <div id="cbox-info" class="checkout-form-list create-account">
                      <p>Create an account by entering the information below. If you are a returning
                        customer please login at the top of the page.</p>
                      <label>Account password <span class="required">*</span></label>
                      <input placeholder="password" type="password">
                    </div>
                  </div>
                </div>
                <div class="different-address">
                  <div class="ship-different-title">
                    <h3>
                      <label>Ship to a different address?</label>
                      <input id="ship-box" type="checkbox">
                    </h3>
                  </div>
                  <div id="ship-box-info">
                    <!-- BILLING FORM HERE  -->
                    <billing-form :countries="countries" />
                    <div class="order-notes">
                      <div class="checkout-form-list checkout-form-list-2">
                        <textarea id="checkout-mess" cols="30" rows="10"
                          placeholder="Notes about your order, e.g. special notes for delivery."></textarea>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </form>
</template>

<script>
import BillingForm from './BillingForm.vue'
export default {
  components: { BillingForm },
  name: 'BillingDetails',
  data() {
    return {
      countries: [
        {
          short: 'mr',
          full: 'Mauritania',
        },
         {
          short: 'uk',
          full: 'London',
        },
         {
          short: 'rou',
          full: 'Romania',
        },
         {
          short: 'fr',
          full: 'France',
        },
         {
          short: 'de',
          full: 'Germany',
        },
      ]
    }
  }
}
</script>

<style>

</style>
